import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CruiseRegionsService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCruiseRegions(): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(this.OBPortalSvcURL + 'GetCruiseRegions', {
      headers: headers,
    });
  }
}
